import { render, staticRenderFns } from "./cookie-scripts-tab.vue?vue&type=template&id=28d7fff8"
import script from "./cookie-scripts-tab.vue?vue&type=script&lang=js"
export * from "./cookie-scripts-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports